var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { Typography } from '@mui/material';
export var BusinessHours = function (_a) {
    var businessHours = _a.businessHours;
    return (_jsxs("div", __assign({ className: "grid gap-4" }, { children: [_jsx(Typography, __assign({ variant: "h5" }, { children: "Unfortunately we are not available at this time." })), _jsx(Typography, __assign({ variant: "subhead", className: "mx-0 text-left" }, { children: "Our business hours are:" })), _jsx("div", __assign({ className: "grid place-items-center" }, { children: _jsx(TableContainer, __assign({ component: Paper }, { children: _jsxs(Table, __assign({ size: "small", "aria-label": "Business hours" }, { children: [_jsx(TableHead, { children: _jsxs(TableRow, { children: [_jsx(TableCell, { children: "Day" }), _jsx(TableCell, { children: "Begin" }), _jsx(TableCell, { children: "End" })] }) }), _jsx(TableBody, { children: Object.entries(businessHours).map(function (_a, index) {
                                    var day = _a[0], _b = _a[1], begin = _b.begin, end = _b.end;
                                    return (_jsxs("tr", { children: [_jsx(TableCell, __assign({ className: "capitalize" }, { children: day })), _jsx(TableCell, { children: begin || '-' }), _jsx(TableCell, { children: end || '-' })] }, "hours-".concat(day)));
                                }) })] })) })) }))] })));
};
